import { useEffect, useRef } from "react";
import Sidebar from "./Sidebar";

const SidebarWrapper = ({ isOpen, onClose }) => {
  const sidebarRef = useRef();

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {/* Background Overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-40 transition-opacity duration-300"></div>
      )}

      {/* Sidebar */}
      <div ref={sidebarRef} className="z-50">
        <Sidebar isOpen={isOpen} onClose={onClose} />
      </div>
    </>
  );
};

export default SidebarWrapper;
